import { axios } from 'utils/axios';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { queryClient } from 'utils/react-query';
import { useNovaToast } from 'hooks/utils/useNovaToast';
import { ToastVariant } from 'types/Toast';
import { ReadIds } from './useReadIds';

export const markAsRead = async (articleId: string): Promise<void> => {
  await axios.put(`read-state/${articleId}`);
};

export const useMarkAsRead = (): UseMutationResult<void, unknown, string, unknown> => {
  const { show } = useNovaToast();

  return useMutation({
    mutationFn: markAsRead,
    onError: () => {
      show({ variant: ToastVariant.ERROR });
    },
    // Patch the cached id list directly instead of invalidating — avoids a
    // full GET /read-state/ids round trip on every single mark, matching
    // the `staleTime` on useReadIds. Mirrors the fix/optimize-fav-page
    // improvement to the likes mutations.
    onSuccess: (_data, articleId) => {
      queryClient.setQueryData<ReadIds>(['read-state'], (current) => {
        if (!current) return current;
        if (current.readIds.includes(articleId)) return current;
        return { readIds: [...current.readIds, articleId] };
      });
      show({
        title: 'Wieder was gelernt! 🎉',
        description: 'Weiter so, dein Wissen wächst!',
        variant: ToastVariant.SUCCESS,
      });
    },
  });
};
